
        <div class="detail-grid-wrapper">
            <app-cs-ag-grid-js
                [config]="params.config"
                (onGridInit)="onGridInit($event)">
            </app-cs-ag-grid-js>
        </div>